export function generateExecuteRequest(message, reqFormatter, respFormatter) {
    return {
        message,
        requestFormatter: reqFormatter,
        responseFormatter: respFormatter,
    };
}
//# sourceMappingURL=GenerateExecuteRequest.js.map